// Mapbox dark futuristic style configuration
export const MAP_STYLE = "mapbox://styles/mapbox/dark-v11";

// Custom layer overrides for Ravelocator aesthetic
export const MAP_CONFIG = {
  style: MAP_STYLE,
  projection: "globe",
  fog: {
    color: "rgb(5, 5, 8)",
    "high-color": "rgb(10, 10, 15)",
    "horizon-blend": 0.05,
  },
};

// Marker colors based on device status
export const MARKER_COLORS = {
  normal:           "#4488ff",  // blue — active, healthy
  rave:             "#ff3399",  // pink — rave detected
  critical_battery: "#ffaa00",  // amber — low battery
  missing_data:     "#ff3355",  // red — active but no data
  inactive:         "#7a7a9a",  // grey — inactive
};

// Status display config for device lists and info boxes
export const STATUS_CONFIG = {
  rave:             { label: "RAVE",           color: "var(--color-pink)",  border: "rgba(255,51,153,0.4)", bg: "rgba(255,51,153,0.08)" },
  normal:           { label: "ONLINE",         color: "var(--color-blue)",  border: "rgba(68,136,255,0.3)",  bg: "rgba(68,136,255,0.08)" },
  critical_battery: { label: "LOW BATTERY",    color: "var(--color-amber)", border: "rgba(255,170,0,0.4)",   bg: "rgba(255,170,0,0.08)" },
  missing_data:     { label: "MISSING DATA",   color: "var(--color-red)",   border: "rgba(255,51,85,0.4)",   bg: "rgba(255,51,85,0.08)" },
  inactive:         { label: "INACTIVE",       color: "var(--color-muted)", border: "var(--color-border)",   bg: "transparent" },
};

export const RAVE_PULSE_COLOR = "#bf00ff";
export const RAVE_PULSE_SIZE  = 60;
